import React, { Component } from "react";
import "./ShowWindow.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMaximize, faMinimize, faXmark } from "@fortawesome/free-solid-svg-icons";

class ShowWindow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hide: false,
      fullScreen: false,
      style: {},
    };
  }

  onCloseClick = (value) => {
    this.setState({ hide: true });
  };

  onPopoutClick = () => {
    const fullscreen = !this.state.fullScreen;
    this.setState({
      fullScreen: fullscreen,
      style: !fullscreen && this.state.style ? this.props.style : {},
    });
  };

  componentWillUnmount() {
    this.sidebarEmitter.remove();
    document.removeEventListener("keydown", this.escFunction, false);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    if (!this.state.fullScreen && this.props.style)
      this.setState({ style: this.props.style });
    // LISTEN FOR SIDEPANEL CHANGES
    this.sidebarEmitter = window.emitter.addListener(
      "sidebarChanged",
      (isSidebarOpen) => this.sidebarChanged(isSidebarOpen)
    );
  }

  sidebarChanged = (isSidebarOpen) => {
    this.forceUpdate();
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.setState({ hide: true });
    }
  };

  // GET STORAGE
  getStorage() {
    const storage = localStorage.getItem(this.storageKey);
    if (storage === null) return [];

    const data = JSON.parse(storage);
    return data;
  }

  render() {
    let className = "";
    if (this.state.hide) className = "sc-hidden";
    else if (this.state.fullScreen) className = "overlay";
    else if (this.props.mode === "full") className = "full";
    else if (!window.sidebarOpen) className = "full";

    let hideScrollClassName = "";
    if (this.props.hideScroll && !this.state.fullScreen)
      hideScrollClassName = "sc-show-window-content-no-scroll";

    return (
      <div
        id="sc-show-window-container"
        className={className}
        style={this.state.style}
      >
        <div className="sc-show-window-header no-print">
          <div className="sc-show-window-header-title">{this.props.title}</div>
          <div
            className="sc-show-window-header-popout-button"
            title={
              this.state.fullScreen ? "Obnoviť nadol" : "Na celú obrazovku"
            }
          >
            {this.state.fullScreen ? (
              <FontAwesomeIcon
                onClick={this.onPopoutClick}
                className="faFulscreen-icon"
                icon={faMinimize}
              />
            ) : (
              <FontAwesomeIcon
                onClick={this.onPopoutClick}
                className="faFulscreen-icon"
                icon={faMaximize}
              />
            )}
          </div>
          <div className="sc-show-window-header-close-button" title="Zatvoriť">
          <FontAwesomeIcon
                className="faFulscreen-icon"
                icon={faXmark}
                onClick={this.onCloseClick}
              />
            {/* <button
              style={{ fontWeight: "bolder" }}
              className="sc-button sc-button-blue sc-show-window-header-button"
              onClick={this.onCloseClick}
            > */}
              {/* X */}
            {/* </button> */}
          </div>
        </div>
        <div
          id="sc-show-window-content"
          className={
            this.props.showFooter
              ? "sc-show-window-content with-footer " + hideScrollClassName
              : "sc-show-window-content " + hideScrollClassName
          }
        >
          {this.props.contents}
        </div>
        <div
          className={
            this.props.showFooter ? "sc-show-window-footer" : "sc-hidden"
          }
        >
          <button className="sc-button" onClick={this.onCloseClick}>
            Zatvoriť okno
          </button>
        </div>
      </div>
    );
  }
}

export default ShowWindow;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context("./images", false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}
